import React from 'react';
import { Chip, Typography } from '@mui/material';
import { formatDate } from '../../common/constants';

const formatAmount = (value) =>
  value === null || value === undefined || value === '' ? '–' : `₹${Number(value).toLocaleString('en-IN')}`;

const formatPercent = (value) =>
  value === null || value === undefined || value === '' ? '–' : `${Number(value)}%`;

const formatSavedOn = (dateTime) => {
  if (!dateTime) return '–';
  const [datePart, timePart] = String(dateTime).split(' ');
  return timePart ? `${formatDate(datePart)} ${timePart.slice(0, 5)}` : formatDate(datePart);
};

const getRuleRows = (rule) => [
  { name: 'EPF', limit: rule.PfBasicLimit, percent: rule.PfBasicPer, minAmt: null },
  { name: 'EPF Admin', limit: null, percent: rule.epfAdminPercent, minAmt: rule.epfAdminMinAmt },
  { name: 'EPF Inspection', limit: null, percent: rule.epfInspectionPercent, minAmt: rule.epfInspectionMinAmt },
  { name: 'EPS', limit: rule.epsSalaryLimit, percent: rule.epsPercent, minAmt: null },
  { name: 'EDLI', limit: rule.edliSalaryLimit, percent: rule.edliPercent, minAmt: rule.edliMinAmt },
  { name: 'EDLI Admin', limit: null, percent: rule.edliAdminPercent, minAmt: rule.edliAdminMinAmt },
  { name: 'EDLI Inspection', limit: null, percent: rule.edliInspectionPercent, minAmt: rule.edliInspectionMinAmt },
];

export default function PFRulesHistoryTable({ history, currentRule }) {
  if (!history || history.length === 0) {
    return (
      <Typography variant="body2" sx={{ color: 'text.secondary' }}>
        No PF rules saved yet.
      </Typography>
    );
  }

  return (
    <div>
      {history.map((rule) => {
        const isCurrent = currentRule && rule.EffectiveFrom === currentRule.EffectiveFrom;
        const isUpcoming = !isCurrent && (!currentRule || rule.EffectiveFrom > currentRule.EffectiveFrom);

        return (
          <div key={rule.EffectiveFrom} style={{ marginBottom: '30px' }}>
            {/* Version Header Card */}
            <div
              className="table-info"
              style={{
                borderRadius: '8px',
                padding: '16px 20px',
                marginBottom: '15px',
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                flexWrap: 'wrap',
                gap: '12px',
                border: '1px solid #0b418e',
              }}
            >
              <div style={{ display: 'flex', gap: '40px', alignItems: 'center', flexWrap: 'wrap' }}>
                <div>
                  <span style={{ fontSize: '13px', fontWeight: '500' }}>Effective From:</span>
                  <span style={{ fontSize: '16px', fontWeight: '600', marginLeft: '8px' }}>
                    {formatDate(rule.EffectiveFrom)}
                  </span>
                </div>
                <div>
                  <span style={{ fontSize: '13px', fontWeight: '500' }}>PF Active:</span>
                  <span style={{ fontSize: '16px', fontWeight: '600', marginLeft: '8px' }}>
                    {rule.PfStatus ? 'Yes' : 'No'}
                  </span>
                </div>
                <div>
                  <span style={{ fontSize: '13px', fontWeight: '500' }}>Saved By:</span>
                  <span style={{ fontSize: '14px', fontWeight: '600', marginLeft: '8px' }}>
                    {rule.CreatedByName || '–'}
                  </span>
                </div>
                <div>
                  <span style={{ fontSize: '13px', fontWeight: '500' }}>Saved On:</span>
                  <span style={{ fontSize: '14px', fontWeight: '600', marginLeft: '8px' }}>
                    {formatSavedOn(rule.CreatedAt)}
                  </span>
                </div>
              </div>
              {isCurrent && <Chip label="Current" color="success" size="small" />}
              {isUpcoming && <Chip label="Upcoming" color="warning" size="small" />}
              {!isCurrent && !isUpcoming && <Chip label="Previous" size="small" />}
            </div>

            {/* Table for Rule Values */}
            <table className="table">
              <thead className="table-dark">
                <tr>
                  <th scope="col">Rule</th>
                  <th scope="col">Salary Limit</th>
                  <th scope="col">Rate</th>
                  <th scope="col">Min Amount</th>
                </tr>
              </thead>
              <tbody>
                {getRuleRows(rule).map((row) => (
                  <tr key={row.name}>
                    <td>{row.name}</td>
                    <td>{formatAmount(row.limit)}</td>
                    <td>{formatPercent(row.percent)}</td>
                    <td>{formatAmount(row.minAmt)}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        );
      })}
    </div>
  );
}
